export const FAVORITE_URL ='/shop/api/favorite/';
export const FAVORITE_LINK_URL ='/shop/favorite/';